import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  SelectInput,
  ReferenceInput,
  ListProps,
} from 'react-admin'

import { Toolbar } from 'components/List'
import { Filters } from './Filters'

const UserFilter = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="email" alwaysOn />
    </Filter>
  )
}

export const ListUsers: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List filters={<UserFilter />} {...rest} data-testid="list">
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" />
        <TextField label="Nome" source="name" />
        <TextField label="Email" source="email" />
        <TextField label="Telefone" source="phone" />
      </Datagrid>
    </List>
  )
}
